import { useState } from 'react';
import { resolveImagePath } from '@/utils/imageResolver';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const mainNavItems = [
    { label: 'Home', href: '/' },
    { label: 'Merchandise', href: '/merchandise' },
    { label: 'Pilot Info', href: '/pilot-info' },
    { label: 'Events', href: '/events' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'Partners and Affiliates', href: '/partners-and-affiliates' },
  ];

  const userNavItems = [
    { label: 'Sign In', href: '/m/login' },
    { label: 'Create Account', href: '/m/create-account' },
    { label: 'Orders', href: '/m/orders' },
    { label: 'My Account', href: '/m/account' },
  ];

  return (
    <header className="bg-gray-900 text-white shadow-sm">
      <div className="w-full">
        <nav className="flex items-center justify-between px-4 py-2 lg:px-6">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" title="Goodspeed Airport 42B" className="flex items-center">
              <img
                src={resolveImagePath('/images/42b-logo.jpg')}
                alt="Goodspeed Airport 42B"
                className="h-12 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation - Main Menu */}
          <div className="hidden lg:flex lg:items-center lg:space-x-8">
            {mainNavItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-white hover:text-gray-300 px-3 py-2 text-sm font-medium uppercase tracking-wide transition-colors duration-200"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Desktop User Menu */}
          <div className="hidden lg:flex lg:items-center lg:space-x-4">
            {/* Search Icon */}
            <button className="text-white hover:text-gray-300 p-2" aria-label="Search">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </button>

            {/* User Account Dropdown */}
            <div className="relative">
              <button
                onClick={() => setIsUserMenuOpen(!isUserMenuOpen)}
                className="text-white hover:text-gray-300 p-2"
                aria-label="User Account"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </button>

              {/* User Dropdown Menu */}
              {isUserMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                  {userNavItems.map((item) => (
                    <a
                      key={item.href}
                      href={item.href}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                      onClick={() => setIsUserMenuOpen(false)}
                    >
                      {item.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-white hover:text-gray-300 p-2"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </nav>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-gray-800 border-t border-gray-700">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {/* Main Navigation */}
              {mainNavItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-white hover:text-gray-300 hover:bg-gray-700 block px-3 py-2 text-base font-medium uppercase tracking-wide transition-colors duration-200"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              
              {/* User Navigation */}
              <div className="border-t border-gray-700 pt-2 mt-2">
                {userNavItems.map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="text-white hover:text-gray-300 hover:bg-gray-700 block px-3 py-2 text-base font-medium transition-colors duration-200"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}